<template>
  <v-container class="visiting" :class="{ isRM: user.role?.includes('RM') }">
    <div id="calendar" v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')">
      <v-sheet height="60">
        <v-toolbar flat>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title
            v-if="$refs.calendar"
            class="subtitle-1 font-weight-bold"
          >
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>日</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>周</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>月</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet style="height: calc(100% - 60px)">
        <v-calendar
          locale="zh"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="update()"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-heart1111</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-html="selectedEvent.details"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </div>
    <VisitingAdmin v-else />
    <v-row class="ma-0 pt-2 toolbar" v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')">
      <!-- <v-btn outlined tile class="primary white--text">导出</v-btn> -->
      <div class="tooltip" style="display: inline-flex;margin: auto;float: left;">
        <span style="margin: auto;line-height: 10px;">已评论</span><span style="background:red;height: 15px; width: 30px;margin: auto;"></span>&nbsp;&nbsp;
        <span style="margin: auto;line-height: 10px;">未评论</span><span style="background:green;height: 15px; width: 30px;margin: auto;"></span>&nbsp;&nbsp;
        <span style="margin: auto;line-height: 10px;">未提交</span><span style="background:yellow;height: 15px; width: 30px;margin: auto;"></span>
      </div>
      <v-spacer></v-spacer>
      <div class="actions">
        <v-btn
          outlined
          tile
          class="success white--text ml-2"
          @click="redirectToAdd"
          >新增</v-btn
        >
        <v-btn
          outlined
          tile
          class="primary white--text ml-2"
          @click="redirectToList"
          >查看区域拜访记录</v-btn
        >
        </div>
    </v-row>
  </v-container>
</template>

<script>
import VisitingAdmin from "./VisitingAdmin.vue";
import { mapState } from "vuex";
import api from "../../api/api";
import moment from 'moment';

export default {
  name: "VisitingMgt",
  components: {
    VisitingAdmin,
  },
  computed: {
    ...mapState(["category", "user"]),
  },
  data: () => ({    
    dealerId: null,
    dealerName: null,
    focus: "",
    type: "month",
    typeToLabel: {
      month: "月",
      week: "周",
      day: "日",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().endOf('month').format('YYYY-MM-DD')
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getVisitingList();
    });
  },
  mounted() {
    this.$refs.calendar?.checkChange();
    //this.getVisitingList();
    this.dealerId=this.$route.query.dealerId
    this.dealerName=this.$route.query.dealerName
  },
  methods: {
    update() {
      if (this.type == "month") {
        this.events = this.events.map((item) => {
          return {
            ...item,
            timed: false,
          };
        });
      } else {
        this.events = this.events.map((item) => {
          return {
            ...item,
            timed: true,
          };
        });
      }
    },
    getVisitingList() {
      api.visit
        .getVisitList({
          salesId: this.user.userId,
          start: this.start,
          end: this.end,
          pageIndex: 0,
          pageSize: 99999999
        })
        .then((res) => {
          const { data, status } = res.data;
          if (data && status == 200) {
            this.events = data.list.map((item) => {
              const start = new Date(item.visitDate);
              const end = new Date(start.getTime() + 9 * 3600 * 1000);
              let colortemp="green";
              if(item.stagingFlag=='1'||item.stagingFlag==1){
                item.dealerName = "(未提交)"+item?.dealerName
                colortemp="yellow"
              }
              if(item.dealerVisitList&&item.dealerVisitList.length>0){
                colortemp="red"
              }
              return {
                name: item?.dealerName,
                start: start,
                end: end,
                color: colortemp,
                //color: this.colors[this.rnd(0, this.colors.length - 1)],
                timed: false,
                id: item.id,
              };
            });
          }
        });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
      
      setTimeout(() => {
        console.log(this.$refs.calendar);
        console.log(this.$refs.calendar._data.lastStart.date);
        console.log(this.$refs.calendar._data.lastEnd.date);
        this.start = this.$refs.calendar._data.lastStart.date;
        this.end  = this.$refs.calendar._data.lastEnd.date
        this.getVisitingList();
      }, 100)
    },
    next() {
      this.$refs.calendar.next();

      setTimeout(() => {
        console.log(this.$refs.calendar._data.lastStart.date);
        console.log(this.$refs.calendar._data.lastEnd.date);
        this.end = this.$refs.calendar._data.lastEnd.date;
        this.start = this.$refs.calendar._data.lastStart.date;
        this.getVisitingList();
      }, 100);
      
    },
    showEvent({ event }) {
      this.$router.push({
        path: `/visiting/detail/${event.id}`,
      });
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        // const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        // const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: first,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    redirectToAdd() {
      let date = "";
      if (this.type == "day") {
        date = this.$refs.calendar.value;
      } else {
        date = this.$refs.calendar.times.now.date;
      }
      this.$router.push({
        path: "/visiting/detail/0",
        query: {
          date: date,
          dealerId: this.dealerId,
          dealerName: this.dealerName,
        },
      });
    },
    redirectToList() {
      this.$router.push({
        path: "/visiting/list",
      });
    }
  },
};
</script>

<style lang="sass">
@media (width <= 490px)
  .visiting.isRM
    overflow-x: hidden
    overflow-y: auto
    #calendar
      height: calc(100% - 70px)!important
    .tooltip
      align-items: center
      justify-content: space-between
      width: 100%
    .actions
      display: flex
      flex-direction: row
      justify-content: space-between
      width: 100%
@media (width <= 325px)
  .visiting
    overflow-x: hidden
    overflow-y: auto
    #calendar
      height: calc(100% - 70px)!important
#calendar
  height: calc(100% - 50px)
  width: 100%
</style>
